import { useNavigate } from "react-router-dom";

import { PagesWrapper } from "../../../styles/components/PagesWrapper.styled";
import * as styled from "./OurManagers.styled";
import TopPageTitle from "../../../components/TopPageTitle/TopPageTitle";
import { useEffect, useState } from "react";
import { getAllManagers } from "../../../helpers/getAllManagers";

function OurManagers({ adminInfo }) {
  const [managers, setManagers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getAllManagers().then((data) => {
      setManagers(data);
    });
  }, []);
  return (
    <PagesWrapper>
      <TopPageTitle value={"Наші менеджери"} />
      <styled.List>
        {adminInfo.accessType !== "all" && (
          <styled.AddManagerItem onClick={() => navigate(`addmanager`)}>
            <styled.ItemTitle>+ Додати менеджера</styled.ItemTitle>
          </styled.AddManagerItem>
        )}
        {managers
          .filter(({ accessType }) => accessType === adminInfo.accessType)
          .map(({ _id, managerId, name }) => (
            <styled.Item key={_id}>
              <styled.ItemTitle>{`${name} - id(${managerId})`}</styled.ItemTitle>
            </styled.Item>
          ))}
      </styled.List>
    </PagesWrapper>
  );
}

export default OurManagers;
